import { NextSeo } from 'next-seo'
import { propOr } from 'ramda'

import useBlogPost from '../stores/use-blog-post'

const postSelector = propOr({}, 'post')

const Seo = () => {
  const post = useBlogPost(postSelector)

  return (
    <NextSeo
      title={post.seo?.title || post.title}
      description={post.seo?.description || post.excerpt || post.description}
      openGraph={{
        images: [
          {
            url: post.image?.src,
          },
        ],
      }}
    />
  )
}

export default Seo
